import SidebarItem from "./sidebar-item.container";

export default SidebarItem;
